// 機能訓練レポートのAction.
import * as Moff from '../constants/MoffAPI';
import { MoffAPI } from '../api/MoffAPI';
import * as MoffAPIConst from '../constants/MoffAPI';

/// 12ヶ月行う.
const getMonthlyDataRepeatFunc = (moff: MoffAPI, userId: string, yearMonthArr: string[],
                                  resultOfInstitutions: any, resultOfGetUser: any) => {
  // LocomoとADL用にYYYY-MMを交互にAPIのパラメータに渡すため重複させる.
  const duplicatedYearMonthArr: string[] = [];
  for (let i = 0; i < yearMonthArr.length; i++) {
    duplicatedYearMonthArr.push(yearMonthArr[i]);
    duplicatedYearMonthArr.push(yearMonthArr[i]);
  }

  const requestFunc = () => {
    return {
      type: Moff.LOADING,
      result: null,
    };
  };

  // '2017-07'のYYYY-MMがキー, 中身は個数(LocomoとADLで片方さえ入れば良い).
  const resultYearMonthObj: object = {};

  // ロコモ, ADLでの結果を格納させる.
  const resultTrainingObj: any = {
    locomo: {},
    adl: {},
  };

  let index: number = 0;

  const currentType = (): number => {
    return (index % 2 === 0) ? MoffAPIConst.LOCOMO_TYPE : MoffAPIConst.ADL_TYPE;
  };

  // ステータス,結果（値 or エラーメッセージ）
  const fetchedFunc = (status: any, result: any, apiType: number) => {
    switch (status) {
      case Moff.LOADING:
        return {
          type: Moff.LOADING,
          result: null,
        };
      case Moff.ERROR:
        return {
          type: Moff.ERROR,
          result: result,
        };
      case Moff.SUCCESS:
        let obj = result;
        let size: number = 0;

        // YYYY-MM-DDのキーがある.
        let key: string = '';
        for (key in obj) {
          if (obj.hasOwnProperty(key)) {
            size++;
          }
        }
 
        // 結果は複数あるので追加する.
        if (size > 0) {
          const objKey: string = duplicatedYearMonthArr[index];
          resultYearMonthObj[objKey] =  size;
        }

        // ロコモ or ADL.
        if (apiType  === MoffAPIConst.LOCOMO_TYPE) {
          // locomoに詰める.
          resultTrainingObj.locomo = Object.assign(resultTrainingObj.locomo, result);
        } else if (apiType === MoffAPIConst.ADL_TYPE) {
          // adlに詰める.
          resultTrainingObj.adl = Object.assign(resultTrainingObj.adl, result);
        }

        // 最後に到達するまではLoading.
        if (index < duplicatedYearMonthArr.length - 1) {
          // APIを再帰的に.
          index++;

          return moff.getMonthlyData(
            currentType(), userId, duplicatedYearMonthArr[index],
            requestFunc,
            fetchedFunc
          );
        } else {
          // 最終的.
          return {
            type: Moff.SUCCESS,
            result: {
              user: resultOfGetUser,
              resultTrainingObj: resultTrainingObj,
              dispYearMonth: resultYearMonthObj,
              institutions: resultOfInstitutions,
            },
          };
        }
      default:
        return {
          type: Moff.ERROR,
          result: '不明なエラーが発生しました.',
        };
    }
  };

  // API.
  return moff.getMonthlyData(
    currentType(), userId, duplicatedYearMonthArr[index],
    requestFunc,
    fetchedFunc
  );
};

// 機能訓練レポート・月選択.
// 以下を複数同時.
// getUser(userId);
// x12
// getMonthlyData(1, userId, '2017-08'); LocomoとADL.
// getMonthlyData(2, userId, '2017-08');
export const getMoffCheckData = (userId: string, yearMonthArr: string[]) => {
  // API
  const moff = MoffAPI.instance;
  if (moff === null) {
    return {
      type: Moff.ERROR,
      result: '不明なエラーが発生しました.',
    };
  }

  return moff.getUser(
    userId,
    () => {
      return {
        type: Moff.LOADING,
        result: null,
      };
    },
    // ステータス,結果（値 or エラーメッセージ）
    (statusOfGetUser: any, resultOfGetUser: any) => {
      switch (statusOfGetUser) {
        case Moff.LOADING:
          return {
            type: Moff.LOADING,
            result: null,
          };
        case Moff.ERROR:
          return {
            type: Moff.ERROR,
            result: resultOfGetUser,
          };
        case Moff.SUCCESS:
          //  自分の施設取得.
          return moff.getInstitutions(
            () => {
              return {
                type: Moff.LOADING,
                result: null,
              };
            },
            // ステータス,結果（値 or エラーメッセージ）
            (status: any, resultOfInstitutions: any) => {
              switch (status) {
                case Moff.LOADING:
                  return {
                    type: Moff.LOADING,
                    result: null,
                  };
                case Moff.ERROR:
                  return {
                    type: Moff.ERROR,
                    result: resultOfInstitutions,
                  };
                case Moff.SUCCESS:
                  return getMonthlyDataRepeatFunc(moff, userId, yearMonthArr, resultOfInstitutions, resultOfGetUser);
                default:
                  return {
                    type: Moff.ERROR,
                    result: '不明なエラーが発生しました.',
                  };
              }
            }
          );
        default:
          return {
            type: Moff.ERROR,
            result: '不明なエラーが発生しました.',
          };
      }
    }
  );
};



// WEBPACK FOOTER //
// ./src/actions/LiterallyReport.tsx